import { StylesConfig } from 'react-select';

export interface Option {
  value: string;
  label: string;
}

export const customStyles: StylesConfig<Option, true> = {
  control: (base, state) => ({
    ...base,
    height: '40px', // Let it adjust dynamically for better alignment
    borderRadius: '4px',
    border: state.isFocused ? '1px solid #007bff' : '1px solid #e3e3e7',
    boxShadow: state.isFocused ? '0 0 0 2px var(--primary-light)' : 'none',
    backgroundColor: 'var(--background)',
    padding: '4px 8px', // Adjust padding for consistent look
    fontSize: '13px',
    transition: 'border-color 0.2s, box-shadow 0.2s',
  }),
  multiValue: (base) => ({
    ...base,
    display: 'inline-flex', // Keep chips inline
    margin: '2px', // Add slight spacing between chips
    borderRadius: '4px',
    backgroundColor: 'var(--accent)',
    color: 'var(--muted-foreground)',
  }),
  multiValueLabel: (base) => ({
    ...base,
    fontSize: '13px',
    color: 'var(--muted-foreground)',
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: 'var(--foreground)',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: 'var(--foreground-muted)',
      color: 'var(--background)',
    },
  }),
  menu: (base) => ({
    ...base,
    zIndex: 999, // Ensure menu is above other components
    backgroundColor: 'hsl(var(--background-2-page))',
    border: '1px solid var(--border)',
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? 'hsl(var(--accent))' : 'transparent',
    color: state.isFocused
      ? 'hsl(var(--accent-foreground))'
      : 'hsl(var(--text-primary))',
    ':hover': {
      backgroundColor: 'hsl(var(--accent))',
      color: 'hsl(var(--accent-foreground))',
    },
  }),
  valueContainer: (base) => ({
    ...base,
    display: 'flex',
    flexWrap: 'nowrap', // Prevent wrapping
    overflowX: 'auto', // Enable horizontal scrolling
    maxHeight: '40px', // Constrain the height to avoid overflow
  }),
};

export const options: Option[] = [
  { value: 'confident', label: 'confident' },
  { value: 'engaging', label: 'engaging' },
  { value: 'authoritative', label: 'authoritative' },
  { value: 'informative', label: 'informative' },
  { value: 'enthusiastic', label: 'enthusiastic' },
];
